<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M20.1 13.7H22.5V2.5H11.3V4.9H20.1V13.7ZM10.5 7.3V11.3H14.5V7.3H16.9V16.9H14.5V13.7H10.5V16.9H8.1V7.3H10.5ZM4.9 11.3V20.1H13.7V22.5H2.5V11.3H4.9Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgHigherLogic',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>